// extracted by mini-css-extract-plugin
export default {"root":"StatusBadge_root__Adth-","status":"StatusBadge_status__tg-YL"};